/**
 * Formate une date "jour seul" (naissance, date de début de contrat…) en JJ/MM/AAAA
 * de façon NEUTRE AU FUSEAU.
 *
 * Bug historique (STU-27) : `new Date("YYYY-MM-DD")` parse en UTC minuit, et
 * `toLocaleDateString()` / date-fns `format()` rendent en heure LOCALE — d'où un
 * décalage d'un jour dès que le fuseau du navigateur ≠ UTC (typiquement les
 * étudiants en fuseau négatif, USA). On force donc le rendu en UTC : la date
 * affichée est toujours celle qui a été saisie/stockée, quel que soit le fuseau.
 *
 * Accepte aussi bien "2006-10-16" que "2026-09-01T00:00:00.000Z".
 */
export const formatDateOnly = (value?: string | null): string =>
  value ? new Date(value).toLocaleDateString('fr-FR', { timeZone: 'UTC' }) : '';
